import * as React from "react";
import { useMemo } from "react";
import { ThemeContext } from "./ThemeProvider";

export const useTheme = () => React.useContext(ThemeContext);

export function useActionsMenuTheme() {
  const { palette } = useTheme();
  return useMemo(() => ({
    components: {
      Menu: {
        itemColor: palette.colorWhiteStrong,
        itemBg: palette.colorPrimaryDark,
        itemHoverColor: palette.colorWhite,
        itemHoverBg: palette.colorMenuItemHoverBg,
      },
    },
  }), [palette]);
}
